import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function HubspotPageTracking() {
    const location = useLocation();

    useEffect(() => {
        window._hsq = window._hsq || [];

        const path = location.pathname + location.search + location.hash;

        window._hsq.push(['setPath', path]);
        window._hsq.push(['trackPageView']);
    }, [location]);

    return null;
}
